import { Cell, NonEditableCell } from '@silevis/reactgrid';
import { format, parse } from 'date-fns';
import { useTheme } from '@mui/material';
import addCell from '../helpers/addCell';
import { Week } from '../../../../../../../../../../../store/planStore';

const useAddMonthsRow = (cells: Cell[], weeks: Week[]) => {
  const theme = useTheme();

  const stableColumns = 2;

  addCell({
    cells,
    rowIndex: 0,
    colIndex: 0,
    Template: NonEditableCell,
    value: 'Month (campaign start/end)',
    sx: {
      background: theme.palette.grpTable.background.default,
      color: theme.palette.grpTable.text.main,
      fontWeight: 500,
      fontSize: '12px',
      textAlign: 'center',
    },
  });
  addCell({
    cells,
    rowIndex: 0,
    colIndex: 1,
    Template: NonEditableCell,
    sx: {
      background: theme.palette.grpTable.background.default,
    },
  });
  weeks.forEach((week, index) => {
    addCell({
      cells,
      rowIndex: 0,
      colIndex: index + stableColumns,
      Template: NonEditableCell,
      value: format(
        parse(week.startingDate, 'dd-MM-yyyy', new Date()),
        'MMM d'
      ),
      sx: {
        background: theme.palette.grpTable.background.month,
        color: theme.palette.grpTable.text.main,
        fontWeight: 700,
        fontSize: '12px',
      },
    });
  });
  addCell({
    cells,
    rowIndex: 0,
    colIndex: weeks.length + stableColumns,
    Template: NonEditableCell,
    value: 'PLAN TOTAL',
    sx: {
      background: theme.palette.grpTable.background.default,
      color: theme.palette.grpTable.text.main,
      fontWeight: 700,
      fontSize: '12px',
    },
  });
};

export default useAddMonthsRow;
